import {defineSlotRecipe} from '@chakra-ui/react3'

const inputRecipe = defineSlotRecipe({
    slots: [
        'group',
        'startElement',
        'endElement',
        'pickerEndElement',
        'iconButton',
        'deleteButton',
        'icon',
        'errorIcon'
    ],
    base: {
        group: {
            width: 'full'
        },
        startElement: {
            display: 'flex',
            alignItems: 'center',
            gap: 'spacing-8',
            insetInlineStart: 'spacing-16',
            width: 'auto',
            paddingInline: '0'
        },
        endElement: {
            display: 'flex',
            alignItems: 'center',
            gap: 'spacing-8'
        },
        pickerEndElement: {
            pointerEvents: 'none'
        },
        iconButton: {
            variant: 'ghost',
            size: 'xs'
        },
        deleteButton: {
            variant: 'plain',
            size: 'xs',
            minWidth: 'auto',
            height: 'auto',
            paddingInline: '0',
            color: 'text.primary',
            textStyle: 'body.small',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            fontWeight: 'normal'
        },
        icon: {
            width: 'spacing-16',
            height: 'spacing-16',
            color: 'icons.primary'
        },
        errorIcon: {
            color: 'text.system.error'
        }
    },
    variants: {
        disabled: {
            true: {
                icon: {
                    opacity: 0.4
                }
            }
        }
    }
})

export default inputRecipe
